<div role="alert" [class]="computedClasses">
  <ng-content></ng-content>
</div>

